import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Replace this firebaseConfig object with the congurations for the project you created on your firebase console.
var firebaseConfig = {
  apiKey: "AIzaSyD0uKECDPafqdaGtB1soay_nQGBRaAmjB4",
  authDomain: "omega-sorter-353009.firebaseapp.com",
  projectId: "omega-sorter-353009",
  storageBucket: "omega-sorter-353009.appspot.com",
  messagingSenderId: "585650645363",
  appId: "1:585650645363:web:3d5d71b80550e5acf83d06",
  measurementId: "G-WZXR1E6DZN",
};

// Initialize Firebase app once
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize messaging
const messaging = getMessaging(app);

// Store listener to prevent duplicate listeners and enable cleanup
let messageListener = null;

export const onMessageListener = () =>
  new Promise((resolve) => {
    // Prevent duplicate listeners - only create one
    if (!messageListener) {
      messageListener = onMessage(messaging, (payload) => {
        console.log("Firebase message received:", payload);
        resolve(payload);
      });
    }
  });

/**
 * Clean up Firebase listeners to prevent memory leaks
 * Call this when user logs out or page unloads
 */
export const cleanupFirebaseListeners = () => {
  if (messageListener) {
    console.log("Cleaning up Firebase message listener");
    // Note: Firebase onMessage doesn't return unsubscribe like Firestore listeners
    // But we set it to null to prevent duplicate registrations
    messageListener = null;
  }
};

export default db;

// Throttle token requests to prevent excessive Firebase operations
let lastTokenRequestTime = 0;
const TOKEN_REQUEST_THROTTLE = 3600000; // 1 hour

export const requestForToken = () => {
  const now = Date.now();
  
  // Prevent requesting token too frequently (throttle to max once per hour)
  if (now - lastTokenRequestTime < TOKEN_REQUEST_THROTTLE) {
    const existingToken = localStorage.getItem("currentToken");
    if (existingToken) {
      console.log("Using cached Firebase token");
      return Promise.resolve();
    }
  }
  
  lastTokenRequestTime = now;
  
  return getToken(messaging, {
    vapidKey:
      "BCsXL_EI6PZuso3Nw2d06jaYN0wdONP8l0AxUGau4hTav35Uxmj_zFDCzFowPDvhZtiHIKIo26P0Qgcmqs9aXMg",
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log("Firebase token obtained");
        // Perform any other neccessary action with the token
        localStorage.setItem("currentToken", currentToken);
      } else {
        // Show permission request UI
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
};
